import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Property } from '@/modules/Property/interfaces/property'
import { showErrors } from '@/utils/snack'
import { ApolloResponse } from '@/interfaces/apollo'
import { dateTimeToDisplay, dateToDisplay, dateToNow } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import PropertyDetailDetail from '@/modules/Property/views/detail.vue'
import AppTabs from '@/components/AppTabs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppCheckbox from '@/components/AppCheckbox.vue'
import AppRadio from '@/components/AppRadio.vue'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import RecordTypesHandler from '@/mixins/record-types'
import { getProperty } from '@/modules/Property/gql/property.gql'

import PropertyDialog from '@/modules/Property/scripts/property-dialog'

@Component({
  components: {
    AppBreadcrumbs,
    PropertyDetailDetail,
    AppTabs,
    AppDialog,
    AppTextSearch,
    AppCheckbox,
    AppRadio
  }
})

export default class PropertyDetail extends mixins(PropertyDialog, RecordTypesHandler) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Property'
    }
  ]

  property: Property | null = null

  tabActive = 0
  tabItems = [
    {
      title: 'Details',
      route: 'PropertyDetailDetail'
    },
    {
      title: 'Additional',
      route: 'PropertyDetailAdditional'
    }
  ]

  disableConfirm = false

  recordTypeIndex = 0

  initState = true

  dateToNow = dateToNow

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  get recordType () {
    if (this.$R.isEmpty(this.recordTypes) || !this.property) {
      return null
    }
    const recordTypeId = this.property.recordType.id
    return this.$R.find((recordType: RecordType) => {
      return recordType.id === recordTypeId
    })(this.recordTypes)
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  async mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    await this.getRecordTypes('PROPERTY')
    this.getProperty()
  }

  @Watch('$route.params.id')
  onRouteParamUpdate (val: string) {
    this.getProperty()
  }

  async getProperty () {
    const propertyId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getProperty,
        variables: {
          propertyId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.property = result.data.getProperty as Property

      if (this.initState) {
        this.breadcrumbs.push({
          text: `${this.property.address}`
        })
        this.initState = false
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async deletePropertyConfirm () {
    await this.deletePropPost()
    this.$router.go(-1)
  }
}
